/**
 * Cross-entity search (P2.1-S4) — backend `/api/v1/admin/search?q=`.
 *
 * Trả về top-N matches cho mỗi nguồn (forms, workflows, notification rules,
 * translations). Auth-required: admin hoặc auditor role.
 */
import { api } from "./client";

export interface FormHit {
  code: string;
  name: string;
  description?: string | null;
}

export interface WorkflowHit {
  code: string;
  name: string;
  description?: string | null;
  status: string;
  version: number;
}

export interface NotificationRuleHit {
  id: string;
  name: string;
  event_type: string;
}

export interface TranslationHit {
  locale: string;
  namespace: string;
  key: string;
  value: string;
}

export interface SearchResponse {
  forms: FormHit[];
  workflows: WorkflowHit[];
  notification_rules: NotificationRuleHit[];
  translations: TranslationHit[];
}

export const searchApi = {
  search: (q: string, limitPerKind = 5): Promise<SearchResponse> =>
    api.get<SearchResponse>("/api/v1/admin/search", {
      query: { q, limit_per_kind: limitPerKind },
    }),
};
